import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import EastIcon from "@mui/icons-material/East";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
  Paper,
  FormControl,
  Grid,
  Alert,
  Snackbar,
  Typography,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import { get, put } from "../../../utils/api";
import styles from "../../../styles/brsr/general.module.css";
import { brsrReview, reviewBRSR } from "../../../utils/companyId";
import ReviewBox from "../../Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";
import BRSRFile from "../../Common/BRSRFile";

const Governance = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [modalupload, setModalUpload] = useState({
    performanceFrequencyDoc: false,
    nameOfAgencyEvaluatingDoc: false,
    reasonOfstatedDoc: false,
    independentAssessmentDoc: false,
    oversightBusinessResponsibilityDoc: false,
    directorStatementESGDoc: false,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData1, setFormData1] = useState({});

  const [error, setErrors] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [disabled, setDisabled] = useState(false);
  const [suppressedTooltipKey, setSuppressedTooltipKey] = useState("");

  const [formData, setFormData] = useState({
    directorStatementESG: "",
    oversightBusinessResponsibility: "",
    independentAssessment: {
      status: true,
      remark: "",
    },
    performanceReviewDirector: {
      principle1: true,
      principle2: true,
      principle3: true,
      principle4: true,
      principle5: true,
      principle6: true,
      principle7: true,
      principle8: true,
      principle9: true,
    },
    performanceCompliance: {
      principle1: false,
      principle2: false,
      principle3: false,
      principle4: false,
      principle5: false,
      principle6: false,
      principle7: false,
      principle8: false,
      principle9: false,
    },
    frequencyReviewDirector: {
      principle1: "",
      principle2: "",
      principle3: "",
      principle4: "",
      principle5: "",
      principle6: "",
      principle7: "",
      principle8: "",
      principle9: "",
    },
    frequencyCompliance: {
      principle1: "",
      principle2: "",
      principle3: "",
      principle4: "",
      principle5: "",
      principle6: "",
      principle7: "",
      principle8: "",
      principle9: "",
    },
    extenalAgencyPolicyEvaluation: {
      principle1: true,
      principle2: true,
      principle3: true,
      principle4: true,
      principle5: true,
      principle6: true,
      principle7: true,
      principle8: true,
      principle9: true,
    },
    nameOfAgencyEvaluating: {
      principle1: "",
      principle2: "",
      principle3: "",
      principle4: "",
      principle5: "",
      principle6: "",
      principle7: "",
      principle8: "",
      principle9: "",
    },
    nonMaterial: {
      principle1: true,
      principle2: true,
      principle3: true,
      principle4: true,
      principle5: true,
      principle6: true,
      principle7: true,
      principle8: true,
      principle9: true,
    },
    notReady: {
      principle1: true,
      principle2: true,
      principle3: true,
      principle4: true,
      principle5: true,
      principle6: true,
      principle7: true,
      principle8: true,
      principle9: true,
    },
    resourceConstraints: {
      principle1: true,
      principle2: true,
      principle3: true,
      principle4: true,
      principle5: true,
      principle6: true,
      principle7: true,
      principle8: true,
      principle9: true,
    },
    plannedNextYear: {
      principle1: true,
      principle2: true,
      principle3: true,
      principle4: true,
      principle5: true,
      principle6: true,
      principle7: true,
      principle8: true,
      principle9: true,
    },
    anotherReason: {
      principle1: true,
      principle2: true,
      principle3: true,
      principle4: true,
      principle5: true,
      principle6: true,
      principle7: true,
      principle8: true,
      principle9: true,
    },
    reasonRemark: {
      principle1: "",
      principle2: "",
      principle3: "",
      principle4: "",
      principle5: "",
      principle6: "",
      principle7: "",
      principle8: "",
      principle9: "",
    },
  });

  const handleChange1 = (field, subField, value) => {
    setFormData((prevState) => {
      if (subField) {
        return {
          ...prevState,
          [field]: {
            ...prevState[field],
            [subField]: value,
          },
        };
      }
      return { ...prevState, [field]: value };
    });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: "",
    }));
  };

  const handleChange = (field, subField, value) => {
    setFormData((prevState) => {
      if (subField) {
        return {
          ...prevState,
          [field]: {
            ...prevState[field],
            [subField]: value,
          },
        };
      }
      return { ...prevState, [field]: value };
    });

    // Remove error when user enters valid data

    if (field === "nameOfAgencyEvaluating" && value.trim()) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[subField]; // Remove the specific field's error
        return newErrors;
      });
    }
  };

  const fetchData = async () => {
    try {
      const res = await get(`/brsr/get?type=SectionB&id=${id}`);
      const res1 = res?.data?.data?.BRSRSectionB?.governanceLeadership;
      if (
        res?.data?.data?.year
          ? res?.data?.data?.year < currentYear - 1
          : false || !brsrReview
      )
        setDisabled(true);
      setFormData1(res1);

      // Normalize boolean fields
      const normalize = (obj) => {
        if (!obj) return obj;
        const normalized = { ...obj };
        Object.keys(normalized).forEach((key) => {
          if (typeof normalized[key] === "string") {
            normalized[key] = normalized[key] === "true";
          }
        });
        return normalized;
      };

      const normalizeDropdown = (obj) => {
        if (!obj) return obj;
        const normalized = { ...obj };
        Object.keys(normalized).forEach((key) => {
          const value = normalized[key];

          // Handle boolean values (convert to empty string)
          if (typeof value === "boolean") {
            normalized[key] = "";
            return;
          }

          // Handle non-standard values
          if (
            value !== "Annually" &&
            value !== "Half yearly" &&
            value !== "Quarterly"
          ) {
            normalized[key] =
              value === "Any other - please specify" ? "" : value;
          }
        });
        return normalized;
      };

      // Apply normalization to all relevant fields
      const normalizedData = res1
        ? {
            ...res1,
            performanceCompliance: normalize(res1.performanceCompliance),
            performanceReviewDirector: normalize(
              res1.performanceReviewDirector,
            ),
            frequencyReviewDirector: normalizeDropdown(
              res1.frequencyReviewDirector,
            ),
            frequencyCompliance: normalizeDropdown(res1.frequencyCompliance),
            // Add other boolean fields here if needed
          }
        : {};

      setFormData((prev) => ({ ...prev, ...normalizedData }));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    let hasErrors = false;

    // Validate external agency fields
    principles.forEach((principle) => {
      if (
        formData.extenalAgencyPolicyEvaluation[principle] &&
        !formData.nameOfAgencyEvaluating[principle]?.trim()
      ) {
        newErrors[principle] = "Agency name is required";
        hasErrors = true;
      }
    });

    // Validate directorStatementESG field
    if (!formData.directorStatementESG.trim()) {
      newErrors.directorStatementESG = "This field is required";
      hasErrors = true;
    }

    // Validate oversightBusinessResponsibility field
    if (!formData.oversightBusinessResponsibility.trim()) {
      newErrors.oversightBusinessResponsibility = "This field is required";
      hasErrors = true;
    }

    // Validate remark when independentAssessment.status is "Yes"
    if (
      formData.independentAssessment.status &&
      !formData.independentAssessment.remark.trim()
    ) {
      newErrors.independentAssessment =
        "Remark is required when 'Yes' is selected";
      hasErrors = true;
    }

    setErrors(newErrors);

    // Return true if errors exist, otherwise false
    return Object.keys(newErrors).length > 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (validateForm()) return;

      await put(`/brsr/update?id=${id}`, {
        governanceLeadership: {
          ...formData1,
          ...formData,
        },
        governanceLeadershipSubmitted: true,
        type: "SectionB",
      })
        .then((res) => {
          setsnackOpen({
            open: true,
            message: res.message,
            severity: "error",
          });
          navigate(`/brsr/section-c/instructions/${id}`);
        })
        .catch((err) => {
          setsnackOpen({
            open: true,
            message: "Error loading data",
            severity: "error",
          });
        });
    } else navigate(`/brsr/section-c/instructions/${id}`);
  };

  const principles = [
    "principle1",
    "principle2",
    "principle3",
    "principle4",
    "principle5",
    "principle6",
    "principle7",
    "principle8",
    "principle9",
  ];

  const getDropdownValue = (principleKey, field) => {
    const value = formData[field]?.[principleKey];
    if (
      value === "Annually" ||
      value === "Half yearly" ||
      value === "Quarterly"
    ) {
      return value;
    }
    // Return "Any other - please specify" when value exists but isn't standard
    return value ? "Any other - please specify" : "";
  };

  const getDropdownTooltipTitle = (principleKey, field) => {
    const selectedValue = getDropdownValue(principleKey, field);
    const customValue = formData[field]?.[principleKey];

    if (selectedValue === "Any other - please specify") {
      return customValue || selectedValue;
    }

    return selectedValue || "";
  };

  const hoverOnlyTooltipProps = {
    arrow: true,
    disableFocusListener: true,
    disableTouchListener: true,
  };

  const getTooltipTitle = (tooltipKey, title) =>
    suppressedTooltipKey === tooltipKey ? "" : title;

  const suppressTooltipUntilMouseLeave = (tooltipKey) => {
    setSuppressedTooltipKey(tooltipKey);
  };

  const clearSuppressedTooltip = (tooltipKey) => {
    setSuppressedTooltipKey((prev) => (prev === tooltipKey ? "" : prev));
  };

  // Handle dropdown changes
  const handleDropdownChange = (field, principleKey, newValue) => {
    if (
      newValue === "Annually" ||
      newValue === "Half yearly" ||
      newValue === "Quarterly"
    ) {
      handleChange(field, principleKey, newValue);
    } else if (newValue === "Any other - please specify") {
      // Clear value to show text field
      handleChange(field, principleKey, "");
    }
  };

  return (
    <>
      <p className={styles.subHeading}>
        II. GOVERNANCE, LEADERSHIP AND OVERSIGHT
      </p>
      <Box>
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            7. Statement of Director responsible for the business responsibility
            report, highlighting ESG related challenges, targets and
            achievements (listed entity has flexibility regarding the placement
            of this disclosure)
          </p>
          <TextField
            minRows={3}
            multiline
            disabled={disabled}
            style={{
              width: "100%",
              padding: "8px",
              margin: "-1rem 0rem 0rem 0.5rem",
              background: "transparent",
              borderRadius: "4px",
            }}
            placeholder="Type Here"
            value={formData.directorStatementESG}
            onChange={(e) =>
              handleChange1("directorStatementESG", null, e.target.value)
            }
            error={!!error.directorStatementESG}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-10px",
                }}
              >
                {error.directorStatementESG}
              </Typography>
            }
          />
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            error,
            setErrors,
            open,
            setOpen,
            Uploadkey: "directorStatementESGDoc",
            ml: 2,
            mt: "-1.5rem",
            removeUpload,
          }}
        />

        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            8. Details of the highest authority responsible for implementation &
            oversight of Business Responsibility Policy/Policies.
          </p>
          <TextField
            minRows={3}
            multiline
            disabled={disabled}
            style={{
              width: "100%",
              padding: "8px",
              background: "transparent",
              margin: "-1rem 0rem 0rem 0.5rem",
              borderRadius: "4px",
            }}
            placeholder="Type Here"
            value={formData.oversightBusinessResponsibility}
            onChange={(e) =>
              handleChange1(
                "oversightBusinessResponsibility",
                null,
                e.target.value,
              )
            }
            error={!!error.oversightBusinessResponsibility}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-10px",
                }}
              >
                {error.oversightBusinessResponsibility}
              </Typography>
            }
          />
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            error,
            setErrors,
            open,
            setOpen,
            Uploadkey: "oversightBusinessResponsibilityDoc",
            ml: 2,
            mt: "-1.5rem",
            removeUpload,
          }}
        />

        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            9. Does the entity have a specified committee of Board/Director
            responsible for decision making on sustainability related issues? If
            Yes, provide details.
          </p>

          <FormControl component="fieldset" sx={{ marginLeft: "0.4rem" }}>
            <RadioGroup
              name="independentAssessmentStatus"
              disabled={disabled}
              value={formData.independentAssessment.status ? "yes" : "no"}
              onChange={(e) =>
                handleChange(
                  "independentAssessment",
                  "status",
                  e.target.value === "yes",
                )
              }
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "10px",
                marginTop: "-10px",
                margin: "-10px 0px 10px 10px",
              }}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>

          {formData?.independentAssessment?.status ? (
            <TextField
              minRows={3}
              multiline
              disabled={disabled}
              style={{
                width: "100%",
                padding: "8px",
                marginLeft: "1rem",
                background: "transparent",
                // border: "1px solid #74757E",
                borderRadius: "4px",
              }}
              placeholder="Type Here"
              value={formData.independentAssessment.remark}
              onChange={(e) =>
                handleChange1("independentAssessment", "remark", e.target.value)
              }
              error={!!error.independentAssessment}
              helperText={
                <Typography
                  variant="body2"
                  color="error"
                  style={{
                    lineHeight: "1.2",
                    margin: "2px 0",
                    color: "#d34040",
                    fontSize: "10px",
                    fontStyle: "italic",
                    marginLeft: "-10px",
                  }}
                >
                  {error.independentAssessment || ""}
                </Typography>
              }
            />
          ) : null}
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            error,
            setErrors,
            open,
            setOpen,
            Uploadkey: "independentAssessmentDoc",
            ml: 3,
            mt: "-1.5rem",
            removeUpload,
          }}
        />
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            10. Details of Review of NGRBCs by the Company:
          </p>
          <TableContainer
            component={Paper}
            sx={{
              mb: 3,
              width: "97.5%",
              borderRadius: "10px",
              marginLeft: "1.5rem",
            }}
          >
            <Table
              sx={{
                width: "100%",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow
                  style={{
                    backgroundColor: "#1C486B",
                  }}
                >
                  <TableCell
                    style={{
                      width: "20%",
                      borderRight: "1px solid #fff",
                      borderBottom: "none",
                    }}
                  ></TableCell>
                  <TableCell
                    colSpan={9} // Span across all columns (1 for Subject + 9 for P1-P9)
                    style={{
                      color: "#fff",
                      fontSize: "15px",
                      fontFamily: "Inter",
                      fontWeight: "600",
                      textAlign: "center", // Center the text
                      borderRight: "1px solid #fff",
                    }}
                  >
                    Indicate whether review was undertaken by Director /
                    Committee of the Board/ Any other Committee
                  </TableCell>
                </TableRow>
                <TableRow
                  style={{
                    backgroundColor: "#1C486B",
                  }}
                >
                  <TableCell
                    //  rowSpan={2}
                    style={{
                      color: "#fff",
                      fontSize: "15px",
                      fontFamily: "Inter",
                      fontWeight: "600",
                      width: "20%",
                      padding: "10px",
                      borderRight: "1px solid #fff",
                    }}
                  >
                    Subject for Review
                  </TableCell>
                  {[...Array(9)].map((_, idx) => (
                    <TableCell
                      key={idx}
                      align="center"
                      style={{
                        color: "#fff",
                        fontWeight: "400",
                        fontSize: "15px",
                        fontFamily: "Inter",
                        width: `${80 / 9}%`,
                        borderRight: "1px solid #fff",
                      }}
                    >
                      P{idx + 1}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {["performanceReviewDirector"].map((field, index) => (
                  <TableRow key={field}>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        width: "20%",
                        // padding:"0px",
                        fontWeight: 600,
                        fontFamily: "Inter",
                        color: "#222222",
                        borderRight: "1px solid #DBDBDB",
                      }}
                    >
                      {
                        "Performance against  above policies and  follow up action"
                      }
                    </TableCell>
                    {[...Array(9)].map((_, idx) => (
                      <TableCell
                        key={idx}
                        align="center"
                        style={{
                          width: `${80 / 9}%`,
                          borderRight: "1px solid #DBDBDB",
                        }}
                      >
                        <RadioGroup
                          row
                          disabled={disabled}
                          value={
                            String(formData[field]?.[`principle${idx + 1}`]) ===
                            "true"
                              ? "yes"
                              : "no"
                          }
                          onChange={(e) =>
                            handleChange(
                              field,
                              `principle${idx + 1}`,
                              e.target.value === "yes",
                            )
                          }
                        >
                          <FormControlLabel
                            value="yes"
                            control={<Radio disabled={disabled} />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio disabled={disabled} />}
                            label="No"
                          />
                        </RadioGroup>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}

                {["performanceCompliance"].map((field, index) => (
                  <TableRow key={field}>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        width: "20%",
                        // padding:"0px",
                        fontWeight: 600,
                        fontFamily: "Inter",
                        color: "#222222",
                        borderRight: "1px solid #DBDBDB",
                      }}
                    >
                      {
                        "Compliance with statutory requirements of relevance to the principles, and, rectification of any non-compliances"
                      }
                    </TableCell>
                    {[...Array(9)].map((_, idx) => (
                      <TableCell
                        key={idx}
                        align="center"
                        style={{
                          width: `${80 / 9}%`,
                          borderRight: "1px solid #DBDBDB",
                        }}
                      >
                        <RadioGroup
                          row
                          disabled={disabled}
                          // value={
                          //   formData[field][`principle${idx + 1}`]
                          //     ? "yes"
                          //     : "no"
                          // }
                          // onChange={(e) =>
                          //   handleChange(
                          //     field,
                          //     `principle${idx + 1}`,
                          //     e.target.value === "yes" // Convert to boolean
                          //   )
                          // }
                          value={
                            String(formData[field]?.[`principle${idx + 1}`]) ===
                            "true"
                              ? "yes"
                              : "no"
                          }
                          onChange={(e) =>
                            handleChange(
                              field,
                              `principle${idx + 1}`,
                              e.target.value === "yes",
                            )
                          }
                        >
                          <FormControlLabel
                            value="yes"
                            control={<Radio disabled={disabled} />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio disabled={disabled} />}
                            label="No"
                          />
                        </RadioGroup>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
          {/* <TableContainer
            component={Paper}
            sx={{
              mb: 3,
              width: "97.5%",
              borderRadius: "10px",
              marginLeft: "1.5rem",
            }}
          >
            <Table
              sx={{
                width: "100%",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow
                  style={{
                    backgroundColor: "#1C486B",
                  }}
                >
                  <TableCell
                    style={{
                      width: "20%",
                      borderRight: "1px solid #fff",
                      borderBottom: "none",
                    }}
                  ></TableCell>
                  <TableCell
                    colSpan={9} // Span across all columns (1 for Subject + 9 for P1-P9)
                    style={{
                      color: "#fff",
                      fontSize: "15px",
                      fontFamily: "Inter",
                      fontWeight: "600",
                      textAlign: "center", // Center the text
                      borderRight: "1px solid #fff",
                    }}
                  >
                    Frequency (Annually/ Half yearly/ Quarterly/ Any other –
                    please specify)
                  </TableCell>
                </TableRow>
                <TableRow
                  style={{
                    backgroundColor: "#1C486B",
                  }}
                >
                  <TableCell
                    style={{
                      color: "#fff",
                      fontSize: "15px",
                      fontFamily: "Inter",
                      fontWeight: "600",
                      width: "20%",
                      borderRight: "1px solid #fff",
                    }}
                  >
                    Subject for Review
                  </TableCell>
                  {[...Array(9)].map((_, idx) => (
                    <TableCell
                      key={idx}
                      align="center"
                      style={{
                        color: "#fff",
                        fontWeight: "400",
                        fontSize: "15px",
                        fontFamily: "Inter",
                        width: `${80 / 9}%`,
                        borderRight: "1px solid #fff",
                      }}
                    >
                      P{idx + 1}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {["frequencyReviewDirector"].map((field, index) => (
                  <TableRow key={field}>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        width: "20%",
                        fontWeight: 600,
                        fontFamily: "Inter",
                        color: "#222222",
                        borderRight: "1px solid #DBDBDB",
                      }}
                    >
                      {
                        "Performance against  above policies and  follow up action"
                      }
                    </TableCell>
                    {[...Array(9)].map((_, idx) => (
                      <TableCell
                        key={idx}
                        align="center"
                        style={{
                          width: `${80 / 9}%`,
                          borderRight: "1px solid #DBDBDB",
                        }}
                      >
                        <RadioGroup
                          row
                          disabled={disabled}
                          value={
                            formData[field][`principle${idx + 1}`]
                              ? "yes"
                              : "no"
                          }
                          onChange={(e) =>
                            handleChange(
                              field,
                              `principle${idx + 1}`,
                              e.target.value === "yes" // Convert to boolean
                            )
                          }
                        >
                          <FormControlLabel
                            value="yes"
                            control={<Radio disabled={disabled} />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio disabled={disabled} />}
                            label="No"
                          />
                        </RadioGroup>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      fontFamily: "Inter",
                      color: "#222222",
                      borderRight: "1px solid #DBDBDB",
                    }}
                  >
                    Compliance with statutory requirements of relevance to the
                    principles, and, rectification of any non-compliances
                  </TableCell>
                  {[...Array(9)].map((_, idx) => (
                    <TableCell
                      key={idx}
                      align="center"
                      sx={{
                        borderRight: "1px solid #DBDBDB",
                        padding: "0px 4px",
                      }}
                    >
                      <TextField
                        size="small"
                        disabled={disabled}
                        value={
                          formData.frequencyCompliance[`principle${idx + 1}`] ||
                          ""
                        }
                        multiline
                        placeholder="Type here"
                        onChange={(e) =>
                          handleChange(
                            "frequencyCompliance",
                            `principle${idx + 1}`,
                            e.target.value
                          )
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none", // Remove default border
                            },
                            "&:hover fieldset": {
                              border: "none", // Remove border on hover
                            },
                            "&.Mui-focused fieldset": {
                              border: "none", // Remove border when focused
                            },
                          },
                        }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer> */}
          <TableContainer
            component={Paper}
            sx={{
              mb: 3,
              width: "97.5%",
              borderRadius: "10px",
              marginLeft: "1.5rem",
            }}
          >
            <Table
              sx={{
                width: "100%",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow
                  style={{
                    backgroundColor: "#1C486B",
                  }}
                >
                  <TableCell
                    style={{
                      width: "20%",
                      borderRight: "1px solid #fff",
                      borderBottom: "none",
                    }}
                  ></TableCell>
                  <TableCell
                    colSpan={9} // Span across all columns (1 for Subject + 9 for P1-P9)
                    style={{
                      color: "#fff",
                      fontSize: "15px",
                      fontFamily: "Inter",
                      fontWeight: "600",
                      textAlign: "center", // Center the text
                      borderRight: "1px solid #fff",
                    }}
                  >
                    Frequency (Annually/ Half yearly/ Quarterly/ Any other –
                    please specify)
                  </TableCell>
                </TableRow>
                <TableRow
                  style={{
                    backgroundColor: "#1C486B",
                  }}
                >
                  <TableCell
                    style={{
                      color: "#fff",
                      fontSize: "15px",
                      fontFamily: "Inter",
                      fontWeight: "600",
                      width: "20%",
                      borderRight: "1px solid #fff",
                    }}
                  >
                    Subject for Review
                  </TableCell>
                  {[...Array(9)].map((_, idx) => (
                    <TableCell
                      key={idx}
                      align="center"
                      style={{
                        color: "#fff",
                        fontWeight: "400",
                        fontSize: "15px",
                        fontFamily: "Inter",
                        width: `${80 / 9}%`,
                        borderRight: "1px solid #fff",
                      }}
                    >
                      P{idx + 1}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {["frequencyReviewDirector"].map((field, index) => (
                  <TableRow key={field}>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        width: "20%",
                        fontWeight: 600,
                        fontFamily: "Inter",
                        color: "#222222",
                        borderRight: "1px solid #DBDBDB",
                      }}
                    >
                      {
                        "Performance against  above policies and  follow up action"
                      }
                    </TableCell>
                    {principles.map((principleKey, idx) => (
                      <TableCell key={idx} align="center">
                        <Tooltip
                          {...hoverOnlyTooltipProps}
                          title={getTooltipTitle(
                            `frequencyReviewDirector-${principleKey}-select`,
                            getDropdownTooltipTitle(
                              principleKey,
                              "frequencyReviewDirector"
                            )
                          )}
                        >
                          <Box
                            component="span"
                            sx={{ display: "block" }}
                            onMouseLeave={() =>
                              clearSuppressedTooltip(
                                `frequencyReviewDirector-${principleKey}-select`
                              )
                            }
                          >
                            <FormControl fullWidth size="small">
                              <Select
                                value={getDropdownValue(
                                  principleKey,
                                  "frequencyReviewDirector"
                                )}
                                onChange={(e) => {
                                  handleDropdownChange(
                                    "frequencyReviewDirector",
                                    principleKey,
                                    e.target.value
                                  );
                                  suppressTooltipUntilMouseLeave(
                                    `frequencyReviewDirector-${principleKey}-select`
                                  );
                                }}
                                disabled={disabled}
                                variant="standard"
                                disableUnderline
                                displayEmpty
                                fullWidth
                              >
                                <MenuItem value="" disabled>
                                  Select
                                </MenuItem>
                                <MenuItem value="Annually">Annually</MenuItem>
                                <MenuItem value="Half yearly">
                                  Half yearly
                                </MenuItem>
                                <MenuItem value="Quarterly">Quarterly</MenuItem>
                                <MenuItem value="Any other - please specify">
                                  Any other - please specify
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </Tooltip>

                        {/* Show text field only when "Any other - please specify" is selected */}
                        {getDropdownValue(
                          principleKey,
                          "frequencyReviewDirector",
                        ) === "Any other - please specify" && (
                          <Tooltip
                            {...hoverOnlyTooltipProps}
                            title={getTooltipTitle(
                              `frequencyReviewDirector-${principleKey}-custom`,
                              formData.frequencyReviewDirector[principleKey] ||
                                ""
                            )}
                          >
                            <Box
                              component="span"
                              sx={{ display: "block" }}
                              onMouseLeave={() =>
                                clearSuppressedTooltip(
                                  `frequencyReviewDirector-${principleKey}-custom`
                                )
                              }
                            >
                              <TextField
                                size="small"
                                fullWidth
                                placeholder="Please specify"
                                value={
                                  formData.frequencyReviewDirector[
                                    principleKey
                                  ] || ""
                                }
                                onChange={(e) => {
                                  handleChange(
                                    "frequencyReviewDirector",
                                    principleKey,
                                    e.target.value
                                  );
                                  suppressTooltipUntilMouseLeave(
                                    `frequencyReviewDirector-${principleKey}-custom`
                                  );
                                }}
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                                sx={{ mt: 1, pl: 1 }}
                                disabled={disabled}
                              />
                            </Box>
                          </Tooltip>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      fontFamily: "Inter",
                      color: "#222222",
                      borderRight: "1px solid #DBDBDB",
                    }}
                  >
                    Compliance with statutory requirements of relevance to the
                    principles, and rectification of any non-compliances
                  </TableCell>

                  {principles.map((principleKey, idx) => (
                    <TableCell key={idx} align="center">
                      <Tooltip
                        {...hoverOnlyTooltipProps}
                        title={getTooltipTitle(
                          `frequencyCompliance-${principleKey}-select`,
                          getDropdownTooltipTitle(
                            principleKey,
                            "frequencyCompliance"
                          )
                        )}
                      >
                        <Box
                          component="span"
                          sx={{ display: "block" }}
                          onMouseLeave={() =>
                            clearSuppressedTooltip(
                              `frequencyCompliance-${principleKey}-select`
                            )
                          }
                        >
                          <FormControl fullWidth size="small">
                            <Select
                              value={getDropdownValue(
                                principleKey,
                                "frequencyCompliance"
                              )}
                              onChange={(e) => {
                                handleDropdownChange(
                                  "frequencyCompliance",
                                  principleKey,
                                  e.target.value
                                );
                                suppressTooltipUntilMouseLeave(
                                  `frequencyCompliance-${principleKey}-select`
                                );
                              }}
                              disabled={disabled}
                              variant="standard"
                              disableUnderline
                              displayEmpty
                              fullWidth
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>
                              <MenuItem value="Annually">Annually</MenuItem>
                              <MenuItem value="Half yearly">
                                Half yearly
                              </MenuItem>
                              <MenuItem value="Quarterly">Quarterly</MenuItem>
                              <MenuItem value="Any other - please specify">
                                Any other - please specify
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Tooltip>

                      {getDropdownValue(principleKey, "frequencyCompliance") ===
                        "Any other - please specify" && (
                        <Tooltip
                          {...hoverOnlyTooltipProps}
                          title={getTooltipTitle(
                            `frequencyCompliance-${principleKey}-custom`,
                            formData.frequencyCompliance[principleKey] || ""
                          )}
                        >
                          <Box
                            component="span"
                            sx={{ display: "block" }}
                            onMouseLeave={() =>
                              clearSuppressedTooltip(
                                `frequencyCompliance-${principleKey}-custom`
                              )
                            }
                          >
                            <TextField
                              size="small"
                              fullWidth
                              placeholder="Please specify"
                              value={
                                formData.frequencyCompliance[principleKey] || ""
                              }
                              onChange={(e) => {
                                handleChange(
                                  "frequencyCompliance",
                                  principleKey,
                                  e.target.value
                                );
                                suppressTooltipUntilMouseLeave(
                                  `frequencyCompliance-${principleKey}-custom`
                                );
                              }}
                              variant="standard"
                              InputProps={{ disableUnderline: true }}
                              sx={{ mt: 1, pl: 1 }}
                              disabled={disabled}
                            />
                          </Box>
                        </Tooltip>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            error,
            setErrors,
            open,
            setOpen,
            Uploadkey: "performanceFrequencyDoc",
            ml: 3,
            mt: "-1.5rem",
            removeUpload,
          }}
        />
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            11. Has the entity carried out independent assessment/ evaluation of
            the working of its policies by an external agency? (Yes/No). If yes,
            provide name of the agency.
          </p>

          <Grid
            container
            spacing={1}
            sx={{ width: "98%", marginLeft: "0.7rem" }}
          >
            {principles.map((principle) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={principle}
                sx={{ minHeight: 110 }}
              >
                <FormControl component="fieldset" fullWidth>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      position: "relative",
                    }}
                  >
                    <p
                      style={{
                        marginTop: "10px",
                        fontWeight: "500",
                        color: "#000000",
                        width: "45%",
                      }}
                    >
                      {principle.replace("principle", "Principle ")}
                    </p>

                    <Box
                      sx={{
                        width: "55%",
                        // position: "relative",
                        paddingRight: "8px",
                      }}
                    >
                      <RadioGroup
                        row
                        disabled={disabled}
                        value={
                          formData.extenalAgencyPolicyEvaluation[principle]
                            ? "yes"
                            : "no"
                        }
                        onChange={(e) =>
                          handleChange(
                            "extenalAgencyPolicyEvaluation",
                            principle,
                            e.target.value === "yes",
                          )
                        }
                        sx={{
                          justifyContent: "flex-end",
                          marginLeft: "-1rem", // Move radio buttons 1rem to the left
                          marginBottom: formData.extenalAgencyPolicyEvaluation[
                            principle
                          ]
                            ? 1
                            : 0,
                        }}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio disabled={disabled} />}
                          label="Yes"
                          sx={{
                            marginRight: 2,
                            "& .MuiFormControlLabel-label": {
                              fontWeight: formData
                                .extenalAgencyPolicyEvaluation[principle]
                                ? 500
                                : 400,
                            },
                          }}
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio disabled={disabled} />}
                          label="No"
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontWeight: formData
                                .extenalAgencyPolicyEvaluation[principle]
                                ? 400
                                : 500,
                            },
                          }}
                        />
                      </RadioGroup>

                      {formData.extenalAgencyPolicyEvaluation[principle] && (
                        <TextField
                          fullWidth
                          size="small"
                          disabled={disabled}
                          multiline
                          placeholder="Name of Agency"
                          error={!!error[principle]}
                          helperText={
                            <Typography
                              variant="body2"
                              color="error"
                              style={{
                                fontSize: "10px",
                                fontStyle: "italic",
                                marginLeft: "-1rem",
                                lineHeight: 1.2,
                              }}
                            >
                              {error[principle]}
                            </Typography>
                          }
                          value={formData.nameOfAgencyEvaluating[principle]}
                          onChange={(e) =>
                            handleChange(
                              "nameOfAgencyEvaluating",
                              principle,
                              e.target.value,
                            )
                          }
                          sx={{
                            position: "absolute",
                            width: "calc(100% - 16px)",
                            bottom: "-45px",
                            left: "0px",
                            "& .MuiInputBase-root": {
                              padding: "8px 12px",
                            },
                            "& .MuiInputBase-input": {
                              fontWeight: 500,
                            },
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                </FormControl>
              </Grid>
            ))}
          </Grid>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            error,
            setErrors,
            open,
            setOpen,
            Uploadkey: "nameOfAgencyEvaluatingDoc",
            ml: 2,
            mt: "-1.5rem",
            removeUpload,
          }}
        />
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            12. If answer to question (1) above is “No” i.e. not all Principles
            are covered by a policy, reasons to be stated:
          </p>
          <TableContainer
            component={Paper}
            sx={{
              mb: 3,
              width: "97.5%",
              borderRadius: "10px",
              marginLeft: "1.5rem",
              // marginTop: "-0.5rem",
            }}
          >
            <Table
              sx={{
                width: "100%",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow
                  style={{
                    backgroundColor: "#1C486B",
                  }}
                >
                  <TableCell
                    style={{
                      color: "#fff",
                      fontSize: "15px",
                      fontFamily: "Inter",
                      fontWeight: "600",
                      width: "20%",
                      borderRight: "1px solid #fff",
                    }}
                  >
                    Disclosure Questions
                  </TableCell>
                  {[...Array(9)].map((_, idx) => (
                    <TableCell
                      key={idx}
                      align="center"
                      style={{
                        color: "#fff",
                        fontWeight: "400",
                        fontSize: "15px",
                        fontFamily: "Inter",
                        width: `${80 / 9}%`,
                        borderRight: "1px solid #fff",
                      }}
                    >
                      P{idx + 1}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {[
                  "nonMaterial",
                  "notReady",
                  "plannedNextYear",
                  "anotherReason",
                ].map((field, index) => (
                  <TableRow key={field}>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        width: "20%",
                        fontWeight: 600,
                        fontFamily: "Inter",
                        color: "#222222",
                        borderRight: "1px solid #DBDBDB",
                      }}
                    >
                      {index === 0
                        ? "The entity does not consider the Principles material to its business."
                        : index === 1
                          ? "The entity is not at a stage to formulate and implement policies"
                          : index === 2
                            ? "Planned in the next financial year"
                            : "Any other reason (please specify)"}
                    </TableCell>

                    {[...Array(9)].map((_, idx) => (
                      <TableCell
                        key={idx}
                        align="center"
                        style={{
                          width: `${80 / 9}%`,
                          height: "8rem",
                          borderRight: "1px solid #DBDBDB",
                          padding: "8px", // Add padding for text field
                        }}
                      >
                        {/* Show TextField only for 'anotherReason' */}
                        {field === "anotherReason" ? (
                          <TextField
                            fullWidth
                            size="small"
                            disabled={disabled}
                            placeholder="Any other reason (please specify)"
                            multiline
                            value={formData.reasonRemark[`principle${idx + 1}`]}
                            onChange={(e) =>
                              handleChange(
                                "reasonRemark",
                                `principle${idx + 1}`,
                                e.target.value,
                              )
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                padding: "0px 8px",
                                fontSize: "0.875rem",
                                "& fieldset": {
                                  border: "none",
                                },
                              },
                            }}
                          />
                        ) : (
                          // Show RadioGroup for other fields
                          <RadioGroup
                            row
                            disabled={disabled}
                            value={
                              formData[field][`principle${idx + 1}`]
                                ? "yes"
                                : "no"
                            }
                            onChange={(e) =>
                              handleChange(
                                field,
                                `principle${idx + 1}`,
                                e.target.value === "yes",
                              )
                            }
                          >
                            <FormControlLabel
                              value="yes"
                              control={<Radio disabled={disabled} />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="no"
                              control={<Radio disabled={disabled} />}
                              label="No"
                            />
                          </RadioGroup>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            error,
            setErrors,
            open,
            setOpen,
            Uploadkey: "reasonOfstatedDoc",
            ml: 3,
            mt: "-1rem",
            removeUpload,
          }}
        />

        {!hide && (
          <>
            {brsrReview ? (
              <Box sx={{ ml: "1.4rem", width: "97.8%" }}>
                <ReviewBox
                  url={`/brsr/review/${id}`}
                  handleSubmit={handleSubmit}
                />
              </Box>
            ) : (
              <Box textAlign="right">
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            padding: "1rem 0",
            width: "100%",
          }}
        >
          {" "}
          <Snackbar
            open={snackOpen.open}
            message={snackOpen.message}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          >
            <Alert
              severity={snackOpen.severity || "info"}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {snackOpen.message || "No message provided"}
            </Alert>
          </Snackbar>
        </div>
      </Box>
    </>
  );
};

export default Governance;
